/* ==========================================================================
   Daisy's Tea — kurv, fragt-bar, produktkort, bundle-bygger og quick view.
   Ingen afhængigheder. Temaets egen kurv-bus er ikke eksponeret, så vi
   opdaterer header-tælleren selv og dispatcher 'daisys:cart-updated'.
   ========================================================================== */
(function () {
  if (window.Daisys) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var kr = function (n) { return (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' kr'; };

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'dz-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- Kurv ---------- */
  function updateHeaderCount(count) {
    document.querySelectorAll('[data-header-cart]').forEach(function (link) {
      if (link.hasAttribute('data-cart-count')) link.setAttribute('data-cart-count', count);
      var badge = link.querySelector('.header__cart-link-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'header__cart-link-count';
        (link.querySelector('.header__icon-with-label-touch-icon') || link).appendChild(badge);
      }
      if (badge) {
        if (count > 0) badge.textContent = count;
        else badge.remove();
      }
    });
    document.querySelectorAll('[data-dz-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  // Formatér beløb med butikkens eget pengeformat (window.theme.moneyFormat),
  // fx "{{amount_with_comma_separator}} kr" → "460,00 kr".
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} kr';
    function group(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (parts[1] ? sep + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  // Beløbet ved kurv-ikonet ("Kurv-label med subtotal" i header-indstillingerne)
  function updateHeaderTotal(cart) {
    document.querySelectorAll('[data-header-cart] [data-cart-count], .header__icon-with-label-touch-label').forEach(function (el) {
      el.setAttribute('data-cart-count', cart.item_count);
      // Udskift kun selve beløbet, så fx "Kurv (0,00 kr)" bevarer sin tekst
      if (/\d/.test(el.textContent)) el.textContent = el.textContent.trim().replace(/\d[\d.,' ]*\d(\s*kr\.?)?|\d(\s*kr\.?)?/i, formatMoney(cart.total_price));
    });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        updateHeaderTotal(cart);
        document.dispatchEvent(new CustomEvent('daisys:cart-updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok || j.status) throw new Error(j.description || j.message || 'add failed');
          return j;
        });
      })
      .then(refreshCart)
      .catch(function (e) {
        console.error('Daisys: add to cart', e);
        toast('Noget gik galt. Prøv igen.');
        throw e;
      });
  }

  /* ---------- Fragt-bar ---------- */
  function initBars() {
    document.querySelectorAll('[data-dz-bar]').forEach(function (bar) {
      if (bar.__dz) return;
      bar.__dz = true;
      var free = parseInt(bar.getAttribute('data-free'), 10) || 39900;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      var prog = bar.querySelector('[data-dz-bar-progress]');
      var done = bar.querySelector('[data-dz-bar-done]');
      var missing = bar.querySelector('[data-dz-bar-missing]');
      var fill = bar.querySelector('[data-dz-bar-fill]');
      var shipUsps = bar.querySelectorAll('[data-dz-shipping-usp]');
      var items = Array.prototype.slice.call(bar.querySelectorAll('.dz-bar__item'));
      var idx = 0, timer = null;
      var mobile = window.matchMedia('(max-width: 759px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      function visible() { return items.filter(function (el) { return !el.hidden; }); }
      function show(i) {
        var v = visible();
        items.forEach(function (el) { el.classList.remove('is-current'); });
        if (!v.length) return;
        idx = ((i % v.length) + v.length) % v.length;
        v[idx].classList.add('is-current');
      }
      function rotate() {
        clearInterval(timer);
        var on = mobile.matches && !reduce.matches && visible().length > 1;
        bar.classList.toggle('is-rotating', on);
        show(0);
        if (on) timer = setInterval(function () { show(idx + 1); }, interval);
      }
      function render(total) {
        prog.hidden = !(total > 0 && total < free);
        done.hidden = total < free;
        // Når fragt-statussen vises, er "Gratis fragt fra 399 kr" overflødig
        shipUsps.forEach(function (el) { el.hidden = total > 0; });
        missing.textContent = kr((free - total) / 100);
        fill.style.width = Math.min(100, (total / free) * 100) + '%';
        rotate();
      }
      render(parseInt(bar.getAttribute('data-total'), 10) || 0);
      document.addEventListener('daisys:cart-updated', function (e) { render(e.detail.cart.total_price); });
      (mobile.addEventListener ? mobile.addEventListener('change', rotate) : mobile.addListener(rotate));
      // Pause mens man holder fingeren/musen på baren
      bar.addEventListener('mouseenter', function () { clearInterval(timer); });
      bar.addEventListener('mouseleave', rotate);
    });
    if (initBars.done) return;
    initBars.done = true;
    // Temaets egne kurv-ændringer (ajax-kurv) udsendes kun som DOM-event hvis
    // custom events er slået til; hent derfor kurven igen når fanen får fokus.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && document.querySelector('[data-dz-bar]')) refreshCart();
    });
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && e.detail.cart) document.dispatchEvent(new CustomEvent('daisys:cart-updated', { detail: { cart: e.detail.cart } }));
    });
  }

  /* ---------- Produktkort ---------- */
  function flashAdded(btn, labelDone, labelIdle) {
    btn.textContent = labelDone;
    btn.classList.add('is-added');
    setTimeout(function () { btn.textContent = labelIdle; btn.classList.remove('is-added'); }, 1400);
  }

  function closeAllSizes(except) {
    document.querySelectorAll('[data-dz-card]').forEach(function (card) {
      if (card === except) return;
      var sizes = card.querySelector('[data-dz-card-sizes]');
      var open = card.querySelector('[data-dz-card-open]');
      if (sizes && !sizes.hidden) { sizes.hidden = true; open.hidden = false; }
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dz-card-open]');
    if (open) {
      var card = open.closest('[data-dz-card]');
      var sizes = card.querySelector('[data-dz-card-sizes]');
      if (sizes) {
        closeAllSizes(card);
        open.hidden = true;
        sizes.hidden = false;
        var first = sizes.querySelector('button:not([disabled])');
        if (first) first.focus();
      } else if (open.dataset.dzVariant) {
        open.disabled = true;
        addItems([{ id: +open.dataset.dzVariant, quantity: 1 }])
          .then(function () { flashAdded(open, 'Lagt i kurven ✓', 'Læg i kurv'); })
          .catch(function () {})
          .then(function () { open.disabled = false; });
      }
      return;
    }

    var size = e.target.closest('[data-dz-card-sizes] [data-dz-variant]');
    if (size) {
      var c = size.closest('[data-dz-card]');
      var btn = c.querySelector('[data-dz-card-open]');
      var box = c.querySelector('[data-dz-card-sizes]');
      box.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      addItems([{ id: +size.dataset.dzVariant, quantity: 1 }])
        .then(function () {
          box.hidden = true;
          btn.hidden = false;
          flashAdded(btn, 'Lagt i kurven ✓', 'Læg i kurv');
        })
        .catch(function () {})
        .then(function () {
          box.querySelectorAll('button').forEach(function (b) { b.disabled = b.hasAttribute('data-soldout'); });
        });
      return;
    }

    var quick = e.target.closest('[data-dz-quick-add]');
    if (quick) {
      quick.disabled = true;
      addItems([{ id: +quick.dataset.dzQuickAdd, quantity: 1 }])
        .then(function () {
          quick.textContent = '✓';
          setTimeout(function () { quick.textContent = '+'; }, 1400);
        })
        .catch(function () {})
        .then(function () { quick.disabled = false; });
      return;
    }

    // Klik udenfor et kort i størrelses-tilstand lukker det
    if (!e.target.closest('[data-dz-card]')) closeAllSizes(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllSizes(null);
  });

  /* ---------- Filter-chips ---------- */
  function chipMatch(chip, types, decaf) {
    if (chip === 'alle') return true;
    if (chip === 'koffeinfri') return !!decaf;
    return types.indexOf(chip) > -1;
  }

  function initChipFilters() {
    document.querySelectorAll('[data-dz-chipfilter]').forEach(function (wrap) {
      if (wrap.__dz) return;
      wrap.__dz = true;
      var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 8;
      var cards = wrap.querySelectorAll('[data-dz-card]');
      var chips = wrap.querySelectorAll('[data-dz-chip]');
      function apply(cat) {
        var shown = 0;
        cards.forEach(function (card) {
          var match = chipMatch(cat, (card.getAttribute('data-types') || '').split(' '), card.hasAttribute('data-decaf'));
          card.hidden = !(match && shown < limit);
          if (match && shown < limit) shown++;
        });
        chips.forEach(function (c) {
          var on = c.getAttribute('data-dz-chip') === cat;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on);
        });
      }
      chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.getAttribute('data-dz-chip')); }); });
      apply('alle');
    });
  }

  /* ---------- Bundle-bygger ---------- */
  function Bundle(el) {
    var data = JSON.parse(el.querySelector('[data-dz-bundle-data]').textContent);
    var teas = data.teas;
    var byHandle = {};
    teas.forEach(function (t) { byHandle[t.handle] = t; });
    var isPage = el.hasAttribute('data-dz-bundle-page');
    var baseLimit = function () { return isPage ? 999 : (window.innerWidth >= 760 ? 12 : 6); };
    var limit = baseLimit();
    var expanded = false;
    var expandBtn = el.querySelector('[data-dz-expand]');
    var st = { g: data.defaultGrams === 200 ? 200 : 100, pack: data.defaultPack || 0, picked: [], filter: 'alle', qv: null, qvIdx: 0, busy: false };
    var qvCache = {};
    var lastFocus = null;

    var $ = function (s) { return el.querySelector(s); };
    var grid = $('[data-dz-minis]');
    var packsEl = $('[data-dz-packs]');
    var gramsEl = $('[data-dz-grams]');
    var chipsEl = $('[data-dz-bundle-chips]');
    var slotsEl = $('[data-dz-slots]');
    var countEl = $('[data-dz-tray-count]');
    var totalEl = $('[data-dz-tray-total]');
    var refEl = $('[data-dz-tray-ref]');
    var saveEl = $('[data-dz-tray-save]');
    var ctaEl = $('[data-dz-tray-cta]');
    var qvEl = $('[data-dz-qv]');

    function pack() { return data.packs[st.pack]; }
    function variantFor(t) { return st.g === 200 ? t.v200 : t.v100; }
    function available(t) { var v = variantFor(t); return !!(v && v.available); }
    function full() { return st.picked.length >= pack().n; }
    function qtyOf(h) { return st.picked.filter(function (x) { return x === h; }).length; }
    function img(t) { return t.leaf || t.glass; }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    // Lager: null = ikke lagerstyret (eller må sælges uden lager) → ingen grænse
    function stockOf(t) { var v = variantFor(t); return v && v.stock != null ? v.stock : Infinity; }
    function stockLeft(t) { return stockOf(t) - qtyOf(t.handle); }
    function canAdd(t) { return !full() && available(t) && stockLeft(t) > 0; }

    function add(h) {
      var t = byHandle[h];
      if (!t || full() || !available(t)) return;
      if (stockLeft(t) <= 0) {
        toast('Der er kun ' + stockOf(t) + ' af ' + t.title + ' på lager');
        return;
      }
      st.picked.push(h);
      render();
    }
    // Fjern valg der overstiger lageret (fx efter skift mellem 100 g og 200 g)
    function trimToStock() {
      var count = {};
      st.picked = st.picked.filter(function (h) {
        var t = byHandle[h];
        if (!t || !available(t)) return false;
        count[h] = (count[h] || 0) + 1;
        return count[h] <= stockOf(t);
      });
    }
    function dec(h) {
      var i = st.picked.lastIndexOf(h);
      if (i > -1) st.picked.splice(i, 1);
      render();
    }

    function renderPacks() {
      gramsEl.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.g === st.g); });
      packsEl.innerHTML = data.packs.map(function (k, i) {
        var on = i === st.pack;
        return '<button type="button" class="dz-pack" role="radio" aria-checked="' + on + '" data-pack="' + i + '">' +
          '<span class="dz-pack__n">' + k.n + ' poser</span>' +
          '<span class="dz-pack__prices"><span class="dz-pack__price">' + kr(k.price[st.g]) + '</span></span>' +
          '<span class="dz-pack__save">Spar op til ' + k.pct + '\u00a0%</span>' +
          (k.badge ? '<span class="dz-pack__badge">' + esc(k.badge) + '</span>' : '') +
          '</button>';
      }).join('');
    }

    function renderChips() {
      chipsEl.querySelectorAll('[data-dz-chip]').forEach(function (c) {
        var on = c.getAttribute('data-dz-chip') === st.filter;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on);
      });
    }

    function renderGrid() {
      var isFull = full();
      var all = teas.filter(function (t) { return chipMatch(st.filter, t.types || [], t.decaf); });
      var list = expanded ? all : all.slice(0, limit);
      if (expandBtn) {
        // Knappen skjules, hvis filteret allerede viser alle teer
        expandBtn.parentNode.hidden = !expanded && all.length <= limit;
        expandBtn.textContent = expanded ? 'Vis færre' : 'Se alle ' + all.length + ' teer';
        expandBtn.setAttribute('aria-expanded', expanded);
      }
      grid.innerHTML = list.map(function (t) {
        var q = qtyOf(t.handle);
        var ok = available(t);
        var dis = canAdd(t) ? '' : ' disabled';
        var left = stockOf(t);
        var stockHint = ok && left !== Infinity && left <= 5
          ? '<div class="dz-mini__stock">' + (q >= left ? 'Ikke flere på lager' : 'Kun ' + left + ' på lager') + '</div>' : '';
        var imgCls = t.leaf ? '' : ' class="is-glass"';
        var control = !ok && q === 0
          ? '<button type="button" class="dz-mini__add" disabled>Udsolgt</button>'
          : q === 0
            ? '<button type="button" class="dz-mini__add" data-add="' + t.handle + '" aria-label="Vælg ' + esc(t.title) + '"' + dis + '>+ Vælg</button>'
            : '<div class="dz-stepper"><button type="button" data-dec="' + t.handle + '" aria-label="Fjern én ' + esc(t.title) + '">−</button><span>' + q + '</span><button type="button" data-add="' + t.handle + '" aria-label="Vælg ' + esc(t.title) + '"' + dis + '>+</button></div>';
        var media = '<img src="' + img(t) + '" alt="' + esc(t.title) + '" loading="lazy"' + imgCls + '>' +
          (t.decaf ? '<span class="dz-pill dz-pill--decaf">Koffeinfri</span>' : '');
        return '<div class="dz-mini' + (q ? ' is-picked' : '') + (ok ? '' : ' is-soldout') + '">' +
          (isPage
            ? '<button type="button" class="dz-mini__media" data-qv="' + t.handle + '" aria-label="Læs mere om ' + esc(t.title) + '">' + media + '</button>'
            : '<a class="dz-mini__media" href="' + t.url + '">' + media + '</a>') +
          '<div class="dz-mini__body">' +
          '<div class="dz-type" style="margin-bottom:2px"><span class="dz-dot dz-dot--' + t.cat + '"></span>' + esc(t.type) + '</div>' +
          '<div class="dz-mini__name">' + esc(t.title) + '</div>' +
          (isPage ? '<div class="dz-mini__spacer"><button type="button" class="dz-mini__more" data-qv="' + t.handle + '">Læs mere →</button></div>' : '<div class="dz-mini__spacer"></div>') +
          stockHint + control + '</div></div>';
      }).join('');
    }

    function renderTray() {
      var k = pack();
      var n = k.n;
      var html = '';
      for (var i = 0; i < n; i++) {
        var t = byHandle[st.picked[i]];
        if (t) {
          html += '<button type="button" class="dz-slot is-filled" data-slot="' + i + '" aria-label="Fjern ' + esc(t.title) + '"><img src="' + img(t) + '" alt=""' + (t.leaf ? '' : ' class="is-glass"') + '></button>';
        } else {
          html += '<span class="dz-slot is-empty" aria-label="Tom plads"><img src="' + data.emptySlot + '" alt=""></span>';
        }
      }
      slotsEl.innerHTML = html;
      var isFull = full();
      countEl.textContent = st.picked.length + ' af ' + n + ' valgt';
      totalEl.textContent = kr(k.price[st.g]);
      // Teerne koster forskelligt, så besparelsen regnes ud fra de valgte teer
      var normal = st.picked.reduce(function (sum, h) { var v = variantFor(byHandle[h]); return sum + (v ? v.price : 0); }, 0) / 100;
      var save = normal - k.price[st.g];
      refEl.textContent = kr(normal);
      saveEl.textContent = 'Du sparer ' + kr(save);
      refEl.hidden = saveEl.hidden = !(isFull && save > 0);
      if (!st.busy) ctaEl.textContent = isFull ? 'Læg pakken i kurv' : 'Vælg ' + (n - st.picked.length) + ' te mere';
      ctaEl.classList.toggle('is-waiting', !isFull);
      ctaEl.setAttribute('aria-disabled', !isFull);
    }

    function render() {
      st.picked = st.picked.slice(0, pack().n);
      renderPacks();
      renderChips();
      renderGrid();
      renderTray();
      if (st.qv) renderQv();
    }

    /* Quick view */
    function openQv(h, trigger) {
      lastFocus = trigger || document.activeElement;
      st.qv = h;
      st.qvIdx = 0;
      qvEl.hidden = false;
      document.documentElement.classList.add('dz-lock');
      renderQv();
      qvEl.querySelector('.dz-qv__close').focus();
      if (!qvCache[h]) {
        fetch(root + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (j) {
          var imgs = (j.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return m.src.split('?')[0].replace(/^\/\//, 'https://') + '?width=900'; });
          if (!imgs.length) imgs = (j.images || []).map(function (s) { return s.split('?')[0].replace(/^\/\//, 'https://') + '?width=900'; });
          var tmp = document.createElement('div');
          tmp.innerHTML = j.description || '';
          var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
          var cut = txt.indexOf('Ingredienser');
          if (cut > 0) txt = txt.slice(0, cut).trim();
          if (txt.length > 360) txt = txt.slice(0, 360).replace(/\s\S*$/, '') + '…';
          qvCache[h] = { imgs: imgs, desc: txt };
          if (st.qv === h) renderQv();
        }).catch(function () {});
      }
    }
    function closeQv() {
      var h = st.qv;
      st.qv = null;
      qvEl.hidden = true;
      document.documentElement.classList.remove('dz-lock');
      // Griddet kan være renderet om mens modalen var åben – find kortet igen
      if (lastFocus && document.contains(lastFocus)) return lastFocus.focus();
      var back = grid.querySelector('.dz-mini__more[data-qv="' + h + '"]') || grid.querySelector('[data-qv="' + h + '"]');
      if (back) back.focus();
    }
    function renderQv() {
      var t = byHandle[st.qv];
      if (!t) return;
      var c = qvCache[t.handle];
      var imgs = c && c.imgs.length ? c.imgs : [t.leaf, t.glass].filter(Boolean);
      var idx = ((st.qvIdx % imgs.length) + imgs.length) % imgs.length;
      var v = variantFor(t);
      var q = qtyOf(t.handle);
      var isFull = full();
      var ok = available(t);
      qvEl.querySelector('[data-qv-img]').src = imgs[idx] || '';
      qvEl.querySelector('[data-qv-img]').alt = t.title;
      qvEl.querySelectorAll('.dz-qv__arrow').forEach(function (a) { a.hidden = imgs.length < 2; });
      qvEl.querySelector('[data-qv-thumbs]').innerHTML = imgs.map(function (src, i) {
        return '<button type="button" class="dz-qv__thumb' + (i === idx ? ' is-active' : '') + '" data-qv-thumb="' + i + '" aria-label="Billede ' + (i + 1) + '"><img src="' + src + '" alt=""></button>';
      }).join('');
      qvEl.querySelector('[data-qv-dot]').className = 'dz-dot dz-dot--' + t.cat;
      qvEl.querySelector('[data-qv-type]').textContent = t.type;
      qvEl.querySelector('[data-qv-name]').textContent = t.title;
      qvEl.querySelector('.dz-qv__box').setAttribute('aria-label', t.title);
      qvEl.querySelector('[data-qv-price]').textContent = v ? kr(v.price / 100) + ' · ' + st.g + ' g' : 'Findes ikke i ' + st.g + ' g';
      qvEl.querySelector('[data-qv-decaf]').hidden = !t.decaf;
      qvEl.querySelector('[data-qv-desc]').textContent = c ? c.desc : t.note;
      qvEl.querySelector('[data-qv-link]').href = t.url;
      var has = qvEl.querySelector('[data-qv-has]');
      has.hidden = q === 0;
      has.textContent = q + ' i din pakke';
      var cta = qvEl.querySelector('[data-qv-add]');
      var noMore = ok && stockLeft(t) <= 0;
      cta.textContent = !ok ? 'Udsolgt' : isFull ? 'Pakken er fuld' : noMore ? 'Ikke flere på lager' : q > 0 ? 'Tilføj en mere' : 'Vælg denne te';
      cta.disabled = !canAdd(t);
    }

    if (qvEl) {
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && st.qv) closeQv(); });
    qvEl.addEventListener('click', function (e) {
      if (e.target === qvEl || e.target.closest('.dz-qv__close')) return closeQv();
      if (e.target.closest('.dz-qv__arrow--prev')) { st.qvIdx--; return renderQv(); }
      if (e.target.closest('.dz-qv__arrow--next')) { st.qvIdx++; return renderQv(); }
      var th = e.target.closest('[data-qv-thumb]');
      if (th) { st.qvIdx = +th.dataset.qvThumb; return renderQv(); }
      if (e.target.closest('[data-qv-add]')) {
        var h = st.qv;
        if (!canAdd(byHandle[h])) return;
        add(h);
        closeQv();
      }
    });
    qvEl.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.stopPropagation(); return closeQv(); }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(qvEl.querySelectorAll('button:not([disabled]):not([hidden]), a[href]'), function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    }

    /* Events */
    el.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-pack]'))) { st.pack = +b.dataset.pack; return render(); }
      if ((b = e.target.closest('[data-dz-grams] [data-g]'))) {
        st.g = +b.dataset.g;
        // Teer uden variant i den nye størrelse fjernes fra pakken
        trimToStock();
        return render();
      }
      if ((b = e.target.closest('[data-dz-bundle-chips] [data-dz-chip]'))) { st.filter = b.getAttribute('data-dz-chip'); return render(); }
      if ((b = e.target.closest('[data-add]'))) return add(b.dataset.add);
      if ((b = e.target.closest('[data-dec]'))) return dec(b.dataset.dec);
      if ((b = e.target.closest('[data-slot]'))) { st.picked.splice(+b.dataset.slot, 1); return render(); }
      if ((b = e.target.closest('[data-qv]')) && qvEl) return openQv(b.dataset.qv, b);
      if (e.target.closest('[data-dz-tray-cta]')) return submit();
      if (e.target.closest('[data-dz-expand]')) {
        expanded = !expanded;
        renderGrid();
        // Ved "Vis færre" scrolles tilbage til starten af listen
        if (!expanded) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    });

    function submit() {
      if (!full() || st.busy) return;
      var k = pack();
      var variantId = st.g === 200 ? k.variant200 : k.variant100;
      if (!variantId) { toast('Noget gik galt. Prøv igen.'); return; }
      var props = { 'Størrelse': st.g + 'g' };
      st.picked.forEach(function (h, i) { props['Te ' + (i + 1)] = byHandle[h].title; });
      props._bundle_id = 'dz-' + Date.now().toString(36);
      st.busy = true;
      ctaEl.textContent = 'Tilføjer…';
      addItems([{ id: +variantId, quantity: 1, properties: props }])
        .then(function () {
          st.picked = [];
          ctaEl.textContent = 'Lagt i kurven ✓';
          setTimeout(function () { st.busy = false; renderTray(); }, 1400);
          render();
        })
        .catch(function () { st.busy = false; renderTray(); });
    }

    window.addEventListener('resize', function () {
      if (isPage) return;
      var next = baseLimit();
      if (next !== limit) { limit = next; renderGrid(); }
    });

    render();
  }

  function init() {
    initBars();
    initChipFilters();
    document.querySelectorAll('[data-dz-bundle]').forEach(function (el) {
      if (!el.__dz) { el.__dz = true; Bundle(el); }
    });
  }

  window.Daisys = { addItems: addItems, refreshCart: refreshCart, toast: toast, init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Tema-editoren genindlæser sections enkeltvis
  document.addEventListener('shopify:section:load', init);
})();
